import tw from 'tailwind-styled-components'

export const EditButton = tw.button`
font-semibold
text-sm
text-white
bg-blueTheme
p-2
rounded-lg
h-[38px]
px-6
hover:brightness-95
transition-all
active:scale-95
w-[263px]
`

export const SaveButton = tw.button`
font-semibold
text-sm
text-white
bg-blueTheme
p-2
rounded-lg
h-[38px]
px-6
hover:brightness-95
transition-all
active:scale-95
w-[90px]
`

export const checkInput = `
relative float-left
-ml-[1.5rem] mr-[6px] mt-[0.15rem] 
h-[1.125rem] w-[1.125rem] appearance-none 
rounded-[0.25rem] border-[0.125rem] border-solid
 border-neutral-300 outline-none before:pointer-events-none 
 before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 
 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] 
 before:content-[''] checked:border-primary checked:bg-yellow-400 checked:before:opacity-[0.16] 
 checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block 
 checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] 
 checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white 
 checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] 
 hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] 
 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] 
 focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] 
 focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem]
  focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]
   checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px 
   checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem]
    checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem]
     checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid 
     checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 
     dark:checked:border-primary dark:checked:bg-primary 
     dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] 
     dark:checked:focus:before:shadow-[0px_0px_0px_13px_#FFFFFF]
`

export const BackButton = tw.button`
px-6
w-[90px]
h-[38px]
inline-flex
items-center
justify-center
border
rounded-lg
border-blueTheme
text-blueTheme
text-sm
cursor-pointer
active:scale-95
transition-colors
hover:brightness-90
`

export const IshikawaContainer = tw.div`
md:mx-12
mx-6
md:my-8
my-4
bg-white
boxShadow
rounded-lg
min-w-[380px]
relative
pb-6
`
export const IshikawaMain = tw.form`
flex
flex-col
justify-center
`
export const IshikawaContent = tw.div`
grid 
grid-cols-3 
gap-2 
w-full
mt-6
`

export const Label = tw.label`
block 
font-semibold
text-xs
text-darkGray
truncate
pb-1
`

export const Top = tw.div`
flex-wrap
flex 
justify-between
pt-6
ml-8
`

export const TopInputs = tw.div`
flex 
flex-wrap
gap-4
mr-6
`

export const TitleIshikawaForm = tw.div`
text-lg
font-semibold
text-blueTheme
`
export const TitleIshikawaDiagram = tw.div`
text-lg
font-semibold
text-blueTheme
px-8 flex flex-row gap-12 mt-6 mb-10
`
export const Subtitle = tw.div`
text-sm
text-darkGray/60
mb-2
w-[80%]
float-left
`

export const inputRequiredStyle = `
border
border-errorText
focus:ring-0
focus:border
focus:border-errorText
`